import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { IAuthor } from "~/utils/interface";
import { Author } from "~/components";

interface ISliderAuthors {
  authors: IAuthor[];
  slidesToShow: number;
}

import "swiper/css";
import "swiper/css/navigation";

const SliderAuthors = ({ authors, slidesToShow }: ISliderAuthors) => {
  return (
    <div>
      <Swiper
        spaceBetween={16}
        slidesPerView={slidesToShow}
        className="books__slider"
        loop
        navigation
        modules={[Navigation]}
        breakpoints={{
          320: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          769: {
            slidesPerView: 5,
            slidesPerGroup: 5,
          },
          992: {
            slidesPerView: 8,
            slidesPerGroup: 8,
          },
          1201: {
            slidesPerView: slidesToShow,
            slidesPerGroup: slidesToShow,
          },
        }}
      >
        {authors?.map((author, bookId) => {
          return (
            author.photo && (
              <SwiperSlide key={`${bookId}_author_slider_${author.author_id}`}>
                <Author
                  author_id={author.author_id}
                  name={author.name}
                  surname={author.surname}
                  photo={author.photo}
                />
              </SwiperSlide>
            )
          );
        })}
      </Swiper>
    </div>
  );
};

SliderAuthors.displayName = "SliderAuthors";
export default SliderAuthors;
